import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStagesPlanWorksStaffGroups: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS,
	},
	getRegulationsStagesPlanWorksStaffGroupPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_PREVIEW,
	},
	getRegulationsStagesPlanWorksStaffGroupPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_POPUP,
	},
	createRegulationsStagesPlanWorksStaffGroup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
	},
	getRegulationsStagesPlanWorksStaffGroup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
	},
	patchRegulationsStagesPlanWorksStaffGroup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
	},
	putRegulationsStagesPlanWorksStaffGroup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
	},
	deleteRegulationsStagesPlanWorksStaffGroup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]
				.DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP,
	},
}
